import { Box, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SideDrawer from "./SideDrawer";
import { getExpiredStatus } from "../store/actions/auth";
import { ExpiredProvider } from "../context/ExpiredContext";

// Routes that should receive no padding/wrapper — they handle their own layout
const FULL_BLEED = ["/telegram", "/contenido"];

const SidebarLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const isFullBleed = FULL_BLEED.includes(location.pathname);
  const [open, setOpen] = useState(true);
  const [expired, setexpired] = useState(false);

  const handleDrawerToggle = () => setOpen(!open);

  const getStatusE = useCallback(() => {
    const unsubscribe = getExpiredStatus((statusExpired) => {
      setexpired(statusExpired);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getStatusE();
  }, [getStatusE]);

  useEffect(() => {
    if (expired && location.pathname !== "/home") {
      navigate("/home", { replace: true });
    }
  }, [expired]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <SideDrawer
        sidebarOpen={open}
        handleDrawerToggle={handleDrawerToggle}
        setOpen={setOpen}
        expired={expired}
      />
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          width: "100%",
          background: "#0D0D0D",
          transition: theme.transitions.create(["padding", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          ...(isFullBleed
            ? { height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }
            : { minHeight: "100vh", pt: { xs: 9, md: 10 }, px: { xs: 2, sm: 3, lg: 4 }, pb: 5 }
          ),
        }}
      >
        <ExpiredProvider value={expired}>
          {isFullBleed ? (
            <Box sx={{ pt: { xs: 9, md: 10 }, flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <Outlet />
            </Box>
          ) : (
            <Box className="wrapper" sx={{ width: "100%", maxWidth: "1680px", mx: "auto" }}>
              <Outlet />
            </Box>
          )}
        </ExpiredProvider>
      </Box>
    </>
  );
};

export default SidebarLayout;
